import { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import Api from '../utils/Api';
import Button from '../components/Button';

const styles = css`
  padding: 20px;
  height: 100vh;
  width: 100vw;
  display: flex;
  font-size: 1.25em;
  flex-direction: column;
  gap: 30px;
  & .welcome {
    margin: 0 auto;
    font-size: 2em;
  }
  & .greeting {
    margin: 0 auto;
  }
  & .form {
    display: flex;
    flex-wrap: wrap;
    width: 60%;
    margin: auto;
    gap:20px;
    & .col {
      min-width: 10em;
      display: flex;
      flex-direction: column;
      gap: 20px;
      flex: 1;
    }
    & .label {
      padding-bottom: 20px;
    }
    & .field {
      padding: 10px;
      & input {
        font-size: 1.25em;
        width: 100%;
      }
      &.submit {
        width: 50%;
        margin-left: auto;
      }
    }
  }

`
const PasswordReset = ({ className }) => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [pwReset, setPwReset] = useState(null);
  const [password, setPassword] = useState('');
  const [verifyPassword, setVerifyPassword] = useState('');
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    const fetchPwReset= async () => {
      
      const [err, pwReset] = await Api.getPwReset(token);
      if (err) {
        
        toast.error(`Error getting password reset request: : ${Api.error(err)}`)
        console.error(err.message);
      } else {
        setPwReset(pwReset);
      }
    }

    fetchPwReset()
  }, [token]);

  useEffect(() => {
    let isDisabled = (!(password && verifyPassword));
    isDisabled = (isDisabled || (password !== verifyPassword));
    setIsDisabled(isDisabled);
  }, [password, verifyPassword])

  const submit = async () => {
    const err = await Api.resetPassword( pwReset.userId, token, password);
    if (err) {
      toast.error(`Error changing password: ${Api.error(err)}`);
      console.error(err);
    } else {
      navigate('/login', { state: { message: 'Password changed successfully. Please Login' } });
    }
  }

  return (
    <div className={className}>
      {
        pwReset &&
        <>
          <div className='greeting'>
            Please change your password
          </div>
          <div className='form'>            
            <div className='col'>
              <div className='field'>
                <div className='label'>
                  Password
                </div>
                <input type='password' value={password} onChange={e => setPassword(e.target.value)} />
              </div>
              <div className='field'>
                <div className='label'>
                  Verify Password
                </div>
                <input type='password' value={verifyPassword} onChange={e => setVerifyPassword(e.target.value)} />
              </div>
              <div className='field submit'>
                <Button disabled={isDisabled} className='accept' onClick={submit}>Register</Button>
              </div>
            </div>
          </div>
        </>
      }
    </div >
  )
}

export default styled(PasswordReset)`${styles}`;